const e = {
  input: {
    S: "2rem",
    M: `${2.5}rem`
  },
  accordions: {
    S: "3rem",
    M: `${5.5}rem`
  },
  badge: {
    S: "1rem",
    M: `${1.5}rem`
  },
  button: {
    S: "2rem",
    M: `${2.25}rem`,
    L: `${2.5}rem`
  }
};
export {
  e as sizes
};
